import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-story-blocks")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-story-blocks")),
  head: () => ({
    meta: [
      { title: "بلوكات أسفل المنتج (وسائط + نصّ) — إدارة" },
      {
        name: "description",
        content: "إدارة بلوك صورة/فيديو وبلوك نصّ تحريريّ أسفل كلّ منتج على حدة.",
      },
    ],
  }),
});
